import { createFileRoute } from '@tanstack/react-router';

import { ensureCodeQualityEnabled } from '@/features/code-quality/guard.js';
import { WorkspaceCodeQuality } from '@/features/code-quality/WorkspaceCodeQuality.js';

/**
 * `/code-quality`: the Code Quality page of the workspace selected in the sidebar, scoped by the
 * switcher like `/developer`. The guard fails closed with the Code Quality flag.
 */
export const Route = createFileRoute('/code-quality')({
  beforeLoad: () => ensureCodeQualityEnabled(),
  component: WorkspaceCodeQuality,
});
